import { useGetCollectionsQuery } from '@/store/api';
/**
 * Platform-services hook for fetching the list of all collections.
 *
 * Wraps the RTK Query `useGetCollectionsQuery` hook.
 * Containers should use this hook instead of importing from
 * `@/store/api` directly.
 *
 * @see src/store/api/cc/collectionsApi.ts
 */
export const useGetCollections = () => {
    const { data, isLoading, isFetching, isError, error, refetch, } = useGetCollectionsQuery();
    const refetchCollections = () => refetch().unwrap();
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
        refetchCollections,
    };
};
